jQuery(document).ready(function($) {
  
  // MegaMenu
  var wW = $(window).width();

    // mobile menu toggle
	$('.menu-toggle').click(function() {
		$('.nav-bar').toggle();
        $('html').toggleClass('hide-scroller');
	});

	if ( wW <= 1024 && wW > 768 ) {
		$('ul.sm-simple > li.has-dropdown > a').click(function(e) {
			e.preventDefault();
			if( $(this).parent().hasClass('active') ) {
				$(this).parent().removeClass('active');
			} else {
				$(this).parent().addClass('active').siblings().removeClass('active');
			}
			e.stopImmediatePropagation();
		});
	}

    $('body').on('click', 'ul.sm-simple li[class*="has-dropdown"] > div.fa', function(e) {
       	var li = $(this).parent();
		if( li.hasClass('active') ) {
			li.toggleClass('active');
		}else{
			li.addClass('active').siblings().removeClass('active');
		}
		e.stopImmediatePropagation();
	});

	// mega-nav custom scripts
    if ( wW <= 768 ) {
      	$('body').on('click', 'ul.sm-simple li[class*="has-dropdown"] > a', function(e) {
          	e.stopImmediatePropagation();
          	var href = $(this).attr('href');
			if( href == '#' ) {
              	var li = $(this).parent();
				if( li.hasClass('active') ) {
					li.removeClass('active');
                }else{
					li.addClass('active').siblings().removeClass('active');
				}
			}
		});
	}
  
    
	$('.mega-nav li.has-mega-dropdown > .mega-wrapper').css('width', wW);
	
    
    $(window).resize(function() {
		var wWr = $(window).width();
		if ( wWr > 768 ) {
            
			$('.mega-nav li.has-mega-dropdown > .mega-wrapper').css('width', wWr);
             
			$('li.has-dropdown.bottom').remove();
		} else {
            
			$('.mega-nav li.has-mega-dropdown > .mega-wrapper').css('width', 'auto');
            
        }
      
      	if ( wWr <= 768 ) {
            $('body').on('click', 'ul.sm-simple li[class*="has-dropdown"] > a', function(e) {
                e.stopImmediatePropagation();
                var href = $(this).attr('href');
                if( href == '#' ) {
                    var li = $(this).parent();
                    if( li.hasClass('active') ) {
                        li.removeClass('active');
                    }else{
                        li.addClass('active').siblings().removeClass('active');
                    }
                }
            });
        }
	});

    $('.has-mega-dropdown').one('mouseenter', function() {
        var mw = $(this).find('.mega-wrapper .wide-child');
        if ( mw.height() > $(window).height() ) {
            mw.addClass('scrollable').css('max-height', 'calc(100vh - ' + $('.navbar').height() + 'px)');
        }
    });
  
    /*$('header').on('mouseenter', '.mega-wrapper.scrollable', function() {
        $('html').addClass('hide-scroller');
      	$('body').addClass('show-nav');
    });
    $('header').on('mouseleave', '.mega-wrapper.scrollable', function() {
        $('html').removeClass('hide-scroller');
        $('body').removeClass('show-nav');
    });*/
  
  

  // Tabs shortcode
  if ($('.bc-tabs').length) {

    $.fn.beocodeTabsSizeCheck = function() {
      
		$.each( $(this), function(){
			var maxWidth = $(this).width();
			var width = 0;
			if( typeof $(this).data('width') == 'undefined' ) {
				$(this).find('.sc-clone').each(function(){
					width += $(this).outerWidth(true);
				});
				$(this).data('width', width);
			} else {
				width = parseInt( $(this).data('width') );
			}
			if( width > maxWidth ) {
				$(this).parent().addClass( 'collapsed' );
			} else {
				$(this).parent().removeClass( 'collapsed' );
			}
		});
	}

    $.fn.beocodeTabsHeightCheck = function() {
      $.each( $(this), function(){
        var height = $(this).outerHeight(true);
        $(this).parent().find('.sc-div').each(function(){
          $(this).css('min-height', height+'px');
        });
      });
	}

    $( '.bc-tabs' ).each( function() {
      var $tabs = $(this);

      if(typeof $tabs.data('processed') != 'undefined') {
        return;  
      }

      $tabs.data('processed', 'true');

      var tabsHtml = '<div class="sc-tabs">';
      $tabs.find( '.sc-div' ).each(function(){
        var id = $(this).attr('id');
        var title = $(this).data('title');
        tabsHtml += '<div class="sc-clone" id="'+id+'"><a href="#'+id+'" data-tab-trigger="'+id+'" class="tab-click"><span>'+title+'</span></a></div>';
        $(this).before('<div class="sc-mobile-tab"><a href="#'+id+' "data-tab-mobile-trigger="'+id+'"><span>'+title+'</span></a></div>');
      });
      tabsHtml += '</div>';
      $tabs.prepend(tabsHtml);

      $(this).find('.sc-tabs').beocodeTabsSizeCheck();
      if($(this).hasClass('v-tabs')) {
        $(this).find('.sc-tabs').beocodeTabsHeightCheck();
      }
    });


    $('body').on('click','a[data-tab-trigger]', function(event) {
      event.preventDefault();
      var $tabs = $(this).parents('.bc-tabs');
      $tabs.find( '.sc-tabs a' ).removeClass('active');
      $(this).addClass('active');
      var id = $(this).attr('href').replace(/^#/,'');

      $tabs.find( '.sc-div:not(#'+id+')' ).removeClass('active-tab-div').addClass('not-active-tab-div');
      $tabs.find( '.sc-div#'+id ).removeClass('not-active-tab-div').addClass('active-tab-div');
    });

    $('.bc-tabs').each(function() {
      $(this).find('.sc-mobile-tab').eq(0).find('a').addClass('active');
    });
    $('body').on('click','a[data-tab-mobile-trigger]', function(event) {
      event.preventDefault();
      if($(this).hasClass('active')) {
        $(this).removeClass('active');
        $(this).parent().parent().find('.sc-div').removeClass('active-tab-div').addClass('not-active-tab-div');
      } else {
        var id = $(this).data('tab-mobile-trigger');
        $('#'+id+' a.tab-click').trigger('click');
        $('a[data-tab-mobile-trigger]').removeClass('active');
        $(this).addClass('active');
        $(this).find('.sc-div:not(#'+id+')').removeClass('active-tab-div').addClass('not-active-tab-div');
        $(this).find('.sc-div#'+id).removeClass('not-active-tab-div').addClass('active-tab-div');
      }
      return false;
    });

    $('.bc-tabs .sc-clone:first-child a').click();

    $( window ).resize(function(){
      $('.bc-tabs .sc-tabs').beocodeTabsSizeCheck();
      $('.bc-tabs.v-tabs .sc-tabs').beocodeTabsHeightCheck();
    });

  }


  // Owl slider shortcode
  if ($('.bc-slider').length) {
    $(".bc-slider").owlCarousel({
      nav: true,
      dots: true,
      autoplay: true,
      autoHeight: true,
      navText: [,],
      lazyLoad: true,
      loop: true,
      navRewind: true,
      autoplayHoverPause: true,
      autoplayTimeout: 5000,
      items: 1,
      animateOut: 'fadeOut',
      animateIn: 'fadeIn',
      smartSpeed: 450,   
    });
  }

  // FAQ Shortcode
  if ($('.faq-wrapper').length) {
    var faq = $('.faq-item-answer').hide();
    $('.faq-item-question').click(function() {
      $(this).toggleClass('active-faq').siblings().removeClass('active-faq');
      $(this).next().toggleClass('active-answer').siblings().removeClass('active-answer');
      faq.slideUp("slow" );
      $(this).next().stop().slideToggle();
      return false;
    });
  }
  
  // Page decription Shortcode
  


  //product page video 1 popup Shortcode
  if ( $( "#bc-product-video-shortcode" ).length ) {
    $('#bc-product-video-btn').magnificPopup({
      removalDelay: 500, //delay removal by X to allow out-animation
      callbacks: {
        beforeOpen: function() {
          this.st.mainClass = this.st.el.attr('data-effect');
        }
      },
      type: 'inline',
      midClick: true
    });
  }; 

  //product page video 2 popup Shortcode
  if ( $( "#bc-product-video-shortcode-2" ).length ) {
    $('#bc-product-video-btn-2').magnificPopup({
      removalDelay: 500, //delay removal by X to allow out-animation
      callbacks: {
        beforeOpen: function() {
          this.st.mainClass = this.st.el.attr('data-effect');
        }
      },
      type: 'inline',
      midClick: true
    });
  };    
  
  // Twitter feed Widget
  if ($('#twitter-load').length) {
    var config1 = { 
      "profile": {"screenName": 'bmthofficial'},
      "domId": 'twitter-load',
      "maxTweets": 2,
      "enableLinks": true, 
      "showUser": true,
      "showTime": true
    };
    twitterFetcher.fetch(config1);
    }
  
    // Newsletter popup
  

    
  // popup for mobile filters
  if ($('.open-filters').length) {
    $('.open-filters').magnificPopup({
      type: 'inline',
      midClick: true,
      
      callbacks: {
        open: function() {
          setTimeout(setExpanders, 500);
        }
      }
      
    });
  }


  //Search Popup
  if ($('#search-popup').length) {
    $('#search-popup-btn').magnificPopup({
      removalDelay: 500, //delay removal by X to allow out-animation
      callbacks: {
        beforeOpen: function() {
          this.st.mainClass = this.st.el.attr('data-effect');
        }
      },
      type: 'inline',
      midClick: true
    });
  }


  

  setTimeout(function() {
    $('.button-list, .additional-text').removeClass('preload');
  }, 1000);

  // CUSTOM ADDITIONS 25-10-2020 by Rich <3

  // Fade Header in
  setTimeout(function() {
    $('header').fadeIn(500);
  }, 500);

  var headerheight = $('header').outerHeight();
  $( ".main-content" ).css("margin-top", headerheight);

  $(window).resize(function() {
    var headerheight = $('header').outerHeight();
    $( ".main-content" ).css("margin-top", headerheight);
  });

  // Nav Stuff
  $('body').on('click', '.header-nav-btn-icon svg', function(e) {
         $('.left-nav-wrapper').addClass('in').fadeIn(500);
  });

  $('body').on('click', '.js-close-nav', function(e) {
    $('.left-nav-wrapper').removeClass('in').fadeIn(500);
  });

  $('body').on('click', 'a.droplink', function(e) {
    e.preventDefault();
  });

  $('body').on('click', 'li.has-dropdown', function(e) {
    $(this).find('ul').toggleClass('child, child-open');
  });



  
});



